import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Useful for showing a loading animation for tables
 * @usage
 * <rx-skeleton-table
 *   [numberOfRows]="5"
 *   [numberOfColumns]="4"
 *   [rowHeight]="40px"
 *   [headerHeight]="48px"
 * />
 *
 * @example It will create a table layout like:
 * [Header] [Header] [Header] [Header]
 * [Cell  ] [Cell  ] [Cell  ] [Cell  ]
 * [Cell  ] [Cell  ] [Cell  ] [Cell  ]
 *
 * @param numberOfRows - The number of rows in the table (excluding header)
 * @param numberOfColumns - The number of columns in the table
 * @param rowHeight - The height of each table row
 * @param headerHeight - The height of the header row
 * @param testId - The test id for automation tests
 */
@Component({
  standalone: true,
  selector: 'rx-skeleton-table',
  imports: [CommonModule],
  styleUrls: ['./skeleton-table.component.scss'],
  templateUrl: './skeleton-table.component.html',
})
export class SkeletonTableComponent {
  @Input() numberOfRows: number = 5;
  @Input() numberOfColumns: number = 4;
  @Input() rowHeight: string = '40px';
  @Input() headerHeight: string = '48px';
  @Input() testId: string = 'test-skeleton-table';

  get headerCells() {
    return Array.from({ length: this.numberOfColumns });
  }

  get cells() {
    return Array.from({ length: this.numberOfColumns });
  }

  get rows() {
    return Array.from({ length: this.numberOfRows });
  }
}
